import script from "./ArticleCardSpecial.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleCardSpecial.vue?vue&type=script&setup=true&lang=js"

import "./ArticleCardSpecial.vue?vue&type=style&index=0&id=4f903f15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f903f15"]])

export default __exports__